import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'inputToggle',
		'enabledInput',
		'disabledInput'
	]

	connect() {
		const checkbox = this.inputToggleTarget
		const listItem = this.element

		this.updateListItem(listItem, checkbox)
	}

	updateFromInputToggle(event) {
		const checkbox = event.currentTarget
		const listItem = checkbox.closest('li')
		this.updateListItem(listItem, checkbox)
	}

	updateListItem(listItem, checkbox) {
		if (checkbox.checked) {
			this.enableItem(listItem)
		} else {
			this.disableItem(listItem)
		}

		checkbox.classList.remove('disabled')
		checkbox.disabled = false
	}

	enableItem(element) {
		if (this.hasEnabledInputTarget || this.hasDisabledInputTarget) {
			this.enabledInputTargets.forEach(inputElement => {
				inputElement.classList.remove('disabled')
				inputElement.removeAttribute('disabled')
			})
			this.disabledInputTargets.forEach(inputElement => {
				inputElement.classList.add('disabled')
				inputElement.disabled = true
			})
		} else {
			element.querySelectorAll('input,select,textarea').forEach( (inputElement) => {
				inputElement.classList.remove('disabled')
				inputElement.removeAttribute('disabled')
			})
		}
	}
	
	disableItem(element) {
		if (this.hasEnabledInputTarget || this.hasDisabledInputTarget) {
			this.enabledInputTargets.forEach(inputElement => {
				inputElement.classList.add('disabled')
				inputElement.disabled = true
			})
			this.disabledInputTargets.forEach(inputElement => {
				inputElement.classList.remove('disabled')
				inputElement.removeAttribute('disabled')
			})
		} else {
			element.querySelectorAll('input,select,textarea').forEach( (inputElement) => {
				inputElement.classList.add('disabled')
				inputElement.disabled = true
			})
		}
	}

}
